import React from "react";
import { Globe, Printer, Puzzle, TabletSmartphone } from "lucide-react";
import { Translate } from "components/common/Translate/Translate";
import {ISection8UseCase, Section8UseCaseScaffold} from "components/features/CompressorCommon/Section8UseCaseScaffold";

const bestUseList: ISection8UseCase[] = [
    {
        title: "Enhances-Web-Performance-heading",
        subTitle: "Enhances-Web-Performance-sub-heading",
        icon: <Globe strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "Fits-Platform-and-Screen-Standards-heading",
        subTitle: "Fits-Platform-and-Screen-Standards-sub-heading",
        icon: <Puzzle />,
    },
    {
        title: "Saves-Storage-Space-heading",
        subTitle: "Saves-Storage-Space-sub-heading",
        icon: <TabletSmartphone />,
    },
    {
        title: "Meets-Platform-Submission-Standards-heading",
        subTitle: "Meets-Platform-Submission-Standards-sub-heading",
        icon: <Printer />,
    },
];
const JpgResizerUseCase = () => {
    return (
        <Section8UseCaseScaffold
            title={<Translate keyName="best-usage-online-tool-title" />}
            useCases={bestUseList}
        />
    );
};

export default JpgResizerUseCase;
